import React from 'react';

const QuickbaseDownloadLink = ({ tableID, fieldID, recordID, children }) => (
  <a href={`/api/quickbase-file/${tableID}/${fieldID}/${recordID}`}>{children}</a>
);

export { QuickbaseDownloadLink };
